const validateTO2 = (rule,value,callback) =>{
  if(!(/^\+?[1-9]{1}[0-9]{0,8}\d{0,0}$/).test(value)){
  // if(!(/^(0?|-?[1-9]\d*)$/).test(value)){
    
    callback(new Error('请输入不超过9位正整数！'));
}else{
    callback();
  }

};
const validateTO3 = (rule,value,callback) =>{
  if(value>=10000){
    callback(new Error('请输入10,000.00以内的数字！'));
  }else{
    callback();
  }
};
import dayjs from 'dayjs'
export function omitNumber(e) {
  let value = e;
  value = value.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
  value = value.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
  value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
  value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); //只能输入两个小数
  if (value.indexOf(".") < 0 && value != "") {
    //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
    value = parseFloat(value);
  }
  if(value=='.'){
    value = '0.'
  }
  return value;
}
export const startOption = {
    column: [
      {
        label: "出发时间",
        prop: "estimateEndTime",
        type: "datetime",
        format: "yyyy-MM-dd HH:mm:ss",
        valueFormat: "yyyy-MM-dd HH:mm:ss",
        span: 24,
        rules: [
          {
            required: true,
            message: '请选择出发时间'
          },
        ]
      },
        {
            type: 'input',
            label: '出发地点',
            span: 24,
            display: true,
            formslot:false,
            prop: 'startSite',
            maxlength: 50,
            showWordLimit: true,
            required: true,
            rules: [
              {
                required: true,
                message: '请填写出发点'
              },
              { min: 0, max: 100, message: '请控制在100个字符内！', trigger: 'change' }
            ]
          },
          {
              label: '车牌号',
              prop: 'carId',
              // search:true,
              span: 24,
              formslot:true,
              rules: [
              {
                  required: true,
                  message: '请选择车牌号',
                  trigger: 'change',
              },
              ],
          },
          {
              label: '车辆类型',
              prop: 'carVehicleName',
              // search:true,
              span: 24,
              type:'input',
              disabled:true,
              rules: [
              // {
              //     required: true,
              //     message: '车辆类型',
              //     trigger: 'change',
              // },
              ],
          },
          {
            type: 'number',
            label: '当前里程数',
            span: 24,
            display: true,
            prop: 'startMileage',
            formslot:true,
            controls: true,
            required: true,
            placeholder:"里程数 (千米)",
            value:'0',
            rules: [
              {
                required: true,
                message: '请输入里程数',
                trigger:'blur'
              },
              { type: 'string',trigger: 'change', validator:validateTO2},
              
            ]
          },
      {
        type: 'textarea',
        label: '备注',
        span: 24,
        display: true,
        formslot:true,
        prop: 'remark',
       maxlength:200,
        // required: true,
        rules: [
          // {
          //   required: true,
          //   message: '请填写备注'
          // },
          { min: 0, max: 200, message: '请控制在200个字符内！', trigger: 'change' }
        ]
      },
      {
        type: 'upload',
        label: '附件',
        span: 24,
        display: true,
        showFileList: true,
        multiple: true,
        limit: 10,
        dataType:'array',
        propsHttp: {},
        canvasOption: {},
        prop: 'attachList',
        formslot:true,
        drag: true,
   
      }
    ],
    labelPosition: 'right',
    labelSuffix: '：',
    labelWidth: 120,
    gutter: 0,
    menuBtn: true,
    submitBtn: false,
    submitText: '保存',
    emptyBtn: false,
    
    menuPosition: 'right',
    detail: false,
    tabs: false
  }

export const endOption = {
    labelPosition: 'right',
      labelSuffix: '：',
      labelWidth: 120,
      gutter: 0,
      menuBtn: true,
      submitBtn: false,
      submitText: '保存',
      emptyBtn: false,
      emptyText: '清空',
      menuPosition: 'right',
      detail: false,
      tabs: false,
      column: [
      {
        label: "结束时间",
        prop: "endTime",
        type: "datetime",
        format: "yyyy-MM-dd HH:mm:ss",
        valueFormat: "yyyy-MM-dd HH:mm:ss",
        span: 24,
        rules: [
          {
            required: true,
            message: '请选择结束时间'
          },
        ]
      },
        {
          type: 'input',
          label: '结束地点',
          span: 24,
          display: true,
          formslot:false,
          prop: 'endSite',
          maxlength: 50,
          showWordLimit: true,
          required: true,
          rules: [
            {
              required: true,
              message: '请填写结束地点'
            },
            { min: 0, max: 50, message: '请控制在50个字符内！', trigger: 'change' }
          ]
        },
        {
          type: 'number',
          label: '当前里程数',
          span: 24,
          display: true,
          prop: 'endMileage',
          formslot:true,
          controls: true,
          required: true,
          value:'0',
          placeholder:"里程数 (千米)",
          rules: [
            {
              required: true,
              message: '请输入当前里程数',
              trigger:'blur'
            },
            { type: 'string',trigger: 'change', validator:validateTO2},
            
          ]
        },
        {
          type: 'input',
          label: '本次出车里程',
          span: 24,
          display: true,
          prop: 'useMileage',
          // formslot:true,
          disabled: true,
          controls: true,
          required: true,
          value:'0',
          placeholder:"里程数 (千米)",
          rules: [
            // {
            //   required: true,
            //   message: '请输入本次出车里程',
            //   trigger:'blur'
            // },
            // { type: 'string',trigger: 'change', validator:validateTO2},
            
          ]
        },
        
        {
          type: 'textarea',
          label: '备注',
          span: 24,
          display: true,
          formslot:true,
          prop: 'remark',
          rules: [
           
            { min: 0, max: 200, message: '请控制在200个字符内！', trigger: 'change' }
          ]
        },
        
        {
          type: 'upload',
          label: '附件',
          span: 24,
          display: true,
          showFileList: true,
          multiple: true,
          limit: 10,
          dataType:'array',
          propsHttp: {},
          canvasOption: {},
          prop: 'attachList',
          formslot:true,
          drag: true,
     
        }
       
      ],
    }
